// extracted by mini-css-extract-plugin
export default {"cardSubItemDetails":"cardSubItemDetails__ZGM3O","withEnhancedPaper":"withEnhancedPaper__ZDA4Z"};